import React from 'react';
import type { BombiixIconProps } from './types';

/** Bombiix Radio Button icon. Exported from Figma (Bombiix 2026). */
const RadioButtonIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path
      d="M16.6286 9.99933C16.6284 6.33878 13.6599 3.37139 9.99933 3.37139C6.33893 3.37163 3.37163 6.33893 3.37139 9.99933C3.37139 13.6599 6.33878 16.6284 9.99933 16.6286C13.6601 16.6286 16.6286 13.6601 16.6286 9.99933ZM18 9.99933C18 14.4175 14.4175 18 9.99933 18C5.58138 17.9998 2 14.4173 2 9.99933C2.00024 5.58153 5.58153 2.00024 9.99933 2C14.4173 2 17.9998 5.58138 18 9.99933Z"
      fill="currentColor"
    />
  </svg>
);

export default RadioButtonIcon;
